import { BrowserRouter, Route, Routes } from "react-router-dom"
import Home from "./screens/Home"
import User from "./User"
import SalesRep from "./SalesRep"
import Admin from "./Admin"
import Login from "./Login"
import AppContextProvider from "./context/AppContext"
import AdminReg from "./screens/admin/AdminReg"
import Sandbox from "./Sandbox"

const App = () => {

  return (
    <BrowserRouter>

      <AppContextProvider>

        <Routes>
          <Route element={<Home />} path="/" />
          <Route element={<Login />} path="/login" />
          <Route element={<AdminReg />} path="/admin_reg" />
          <Route element={<User />} path="/user/*" />
          <Route element={<SalesRep />} path="/sales_rep/*" />
          <Route element={<Admin />} path="/admin/*" />
          <Route element={<Sandbox />} path="/sandbox" />
        </Routes>

      </AppContextProvider>

    </BrowserRouter>
  )
}

export default App